import { render, staticRenderFns } from "./PolizzaTabProvvigionale.vue?vue&type=template&id=01b9626e&scoped=true"
import script from "./PolizzaTabProvvigionale.vue?vue&type=script&lang=js"
export * from "./PolizzaTabProvvigionale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b9626e",
  null
  
)

export default component.exports